import React from "react";

export function checkIfHasData(model) {
  return model.meds.length > 0;
}

export default function MedsTile({ model, title }) {
  let hasData = checkIfHasData(model);
  return (
    <React.Fragment>
      <div className="title">{title}</div>
      <div className="tile-content meds">
        {!hasData && <div className="no-results">No Active Meds</div>}
        {hasData && (
          <div>
            <div className="count">{model.meds.length}</div>
            {model.meds.map((med, i) => (
              <p key={i}>{med}</p>
            ))}
          </div>
        )}
      </div>
    </React.Fragment>
  );
}
